import React from 'react';

export default class HEAdminRegistration extends React.Component {
  render() {
    return null;
  }
}
